import { FC } from "react";
import { View, Text } from "react-native";
import GreenIcon from "@/assets/icons/main/greenAlert.svg"
import OrangeIcon from "@/assets/icons/main/orangeAlert.svg"
import BlueIcon from "@/assets/icons/main/blueAlert.svg"
import RedIcon from "@/assets/icons/main/redAlert.svg"
import css from "./RiskIndicator.module.css";


export type RiskLevelType = "green" | "yellow" | "red" | "wait";

interface IRiskIndicatorProps {
  level: RiskLevelType;
  text?: string;
}

const icons = {
  green: <GreenIcon className="w-6 h-6" />,
  yellow: <OrangeIcon className="w-6 h-6" />,
  red: <RedIcon className="w-6 h-6" />,
  wait: <BlueIcon className="w-6 h-6" />
};

const RiskIndicator: FC<IRiskIndicatorProps> = ({ level, text }) => {
  const defaultTexts = {
    green: 'Высокий рейтинг надежности. В работе компании риски не найдены.',
    yellow: 'Средний рейтинг надежности. В работе компании найдены риски.',
    red: 'Низкий рейтинг надежности. В работе компании найдены риски.',
    wait: 'Мы формируем отчет, это займет некоторое время. Пожалуйста, подождите.',
  };

  return (
    <View className={`${css.container} ${css[level]}`}>
      {icons[level]}
      <Text className="text-base flex-1 text-left">
        {text || defaultTexts[level]}
      </Text>
    </View>
  );
};

export default RiskIndicator;
